import * as yup from "yup";

// Constants matching those used in BackgroundQuestions component
const COMMENT_CHARACTER_LIMIT = 2500;
const MAX_LENGTH_MESSAGE = `Can't be longer than ${COMMENT_CHARACTER_LIMIT} characters.`;

/**
 * Yup validation schema for GEAO onboarding background information form.
 * This schema validates boolean responses to various background check questions
 * that are required for the agent onboarding process.
 * 
 * @type {import('yup').ObjectSchema}
 * @constant
 * @description Validation schema containing boolean fields for background information questions.
 * All fields are required and must have a boolean value selected.
 */
export const validationSchema = yup.object({
    hasFiledForBankruptcy: yup.bool().required("Please make a selection."),
    hasFiledForBankruptcyComment: yup.string().trim().when("hasFiledForBankruptcy", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    hasDelinquentUnpaidDebts: yup.bool().required("Please make a selection."),
    hasDelinquentUnpaidDebtsComment: yup.string().trim().when("hasDelinquentUnpaidDebts", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    hasBeenSubjectOfAnAdministrativeProceeding: yup.bool().required("Please make a selection."),
    hasBeenSubjectOfAnAdministrativeProceedingComment: yup.string().trim().when("hasBeenSubjectOfAnAdministrativeProceeding", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    hasLicenseBeenSuspended: yup.bool().required("Please make a selection."),
    hasLicenseBeenSuspendedComment: yup.string().trim().when("hasLicenseBeenSuspended", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    hasHadTerminatedContractFromMisconduct: yup.bool().required("Please make a selection."),
    hasHadTerminatedContractFromMisconductComment: yup.string().trim().when("hasHadTerminatedContractFromMisconduct", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    hasPriorConviction: yup.bool().required("Please make a selection."),
    hasPriorConvictionComment: yup.string().trim().when("hasPriorConviction", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    isSubjectOfInvestigation: yup.bool().required("Please make a selection."),
    isSubjectOfInvestigationComment: yup.string().trim().when("isSubjectOfInvestigation", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    }),

    hasBusinessRelationshipWithGEICOEmployee: yup.bool().required("Please make a selection."),
    hasBusinessRelationshipWithGEICOEmployeeComment: yup.string().trim().when("hasBusinessRelationshipWithGEICOEmployee", {
        is: true,
        then: (schema) => schema
            .required("This field is required.")
            .max(COMMENT_CHARACTER_LIMIT, MAX_LENGTH_MESSAGE),
        otherwise: (schema) => schema.notRequired()
    })
});
